import { Link, useParams, useNavigate } from "react-router-dom";
import "./ChangePass.css";
import React, { useState, useContext } from 'react';
//import queryString from "query-string";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Slide, Stack } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { validarCambioPassword } from "global/util/validators";
import { createTheme } from "@mui/material/styles";
import { blue, orange } from '@mui/material/colors';
import { TransitionProps } from '@mui/material/transitions';
import { Amplify } from 'aws-amplify';
import { getCurrentUser, updatePassword } from 'aws-amplify/auth';
import awsconfig from '../../../aws-config';
import CircularProgress from '@mui/material/CircularProgress'; 
import { useAuth } from 'global/context/AuthProviderV2';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface CurrentUser {
    username: string;
    userId: string;
    signInDetails: any; // O define un tipo más específico según corresponda
  }

//Amplify.configure(awsconfig);


export const Changepass = () => {

    const [showPasswordOld, setShowPasswordOld] = useState(false);
    const handleClickShowPasswordOld = () => setShowPasswordOld((show) => !show);
    const handleMouseDownPasswordOld = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const handleClickShowPasswordConfirm = () => setShowPasswordConfirm((show) => !show);
    const handleMouseDownPasswordConfirm = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const [passwordOld, setPasswordOld] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showErrors, setShowErrors] = useState<any>({ state: true, errors: [] })

    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [loginError, setLoginError] = useState('');

    const navigate = useNavigate();
    const { logout  } = useAuth();

    const handleCloseModal = () => {
        setOpen(false);
        logout();
    };

    const [login, setLogin] = useState<CurrentUser|null>(null );

    React.useEffect(() => {
        const validaUser = async () => {
            console.log('validando usuario');
            try {
                const login = await getCurrentUser() as CurrentUser;

                console.log("login:", JSON.stringify(login));
                setLogin(login);
                //setUserId(userId);
            } catch (e) {
                console.log(JSON.stringify(e));
                //setUserId('');
                setLogin(null);
            }
        };
        validaUser();
    }, []);

    const handleChange = async () => {
        if(loading){
            return;
        }
        try {
            setLoading(true)
            setShowErrors(validarCambioPassword({ passwordOld, password, confirmPassword }));
            if (!showErrors.state) {
                return;
            }
            ////////

            console.log('JSON.stringify(login)');
            console.log(JSON.stringify(login));
            if (login){
                console.log('va a cambiar')
                const data = await updatePassword({oldPassword:passwordOld, newPassword: password});
                console.log(JSON.stringify(data));
            }
            
            //userContext.user = null;
            setLoginError('');
            ///////
            console.log(showErrors)
            setOpen(true);
        } catch (error) {
            console.error("Ha ocurrido un error: ", error)
            setLoginError(processChangePasswordError(error));
        }finally{
            setLoading(false)
        }
    };

    const processChangePasswordError = (error: any): string => {
        switch (error?.code) {
            case 'NotAuthorizedException':
                return 'Credenciales inválidas. Por favor, verifica tu contraseña actual.';
            case 'PasswordResetRequiredException':
                return 'Debes restablecer tu contraseña antes de poder cambiarla.';
            case 'CodeMismatchException':
                return 'El código de confirmación proporcionado no es válido.';
            case 'LimitExceededException':
                return 'Has excedido el límite de intentos. Por favor, espera un momento antes de intentar nuevamente.';
            case 'PasswordResetRequiredException':
                return 'Debes restablecer tu contraseña antes de poder cambiarla.';
            case 'CodeMismatchException':
                return 'El código de confirmación proporcionado no es válido.';
            case 'LimitExceededException':
                return 'Has excedido el límite de intentos. Por favor, espera un momento antes de intentar nuevamente.';
            case 'ExpiredCodeException':
                return 'El código de confirmación ha expirado. Por favor, solicita uno nuevo.';
            case 'InvalidPasswordException':
                return 'La contraseña debe contener números, caracteres especiales, mayúsculas y minúsculas.';
            default:
                return 'Ha ocurrido un error inesperado. Por favor, intenta nuevamente.';
        }
    };
    return (
        <div style={{ width: "80%", margin: "0px auto", maxWidth: "900px", display: "grid", gridTemplateColumns: "1fr", gap: "10px", }}>
            {/*<Box
                className="home-component"
                sx={{ width: 400, marginTop: 3, marginBottom: 5, backgroundColor: "transparent" }}
            >
                <p>CaPS es un programa de transformaci&oacute;n de capacidades de I+D en productos y servicios que respondan a necesidades de la industria.</p>
            </Box> */}
            <Box
                className="home-component"
                sx={{ width: 400, marginTop: 3, marginBottom: 5, backgroundColor: "white" }}
            >
                <div className="registration-container">
                    <h2>Cambio de contraseña</h2>

                    <FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Contraseña actual</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPasswordOld ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPasswordOld}
                                        onMouseDown={handleMouseDownPasswordOld}
                                        edge="end"
                                    >
                                        {showPasswordOld ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Contraseña actual"
                            value={passwordOld}
                            onChange={(e) => setPasswordOld(e.target.value)}
                        />
                    </FormControl>
                    {/*
					<FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
						<label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-colorPrimary MuiFormLabel-filled MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined css-1jy569b-MuiFormLabel-root-MuiInputLabel-root" >
							La contraseña nueva debe contener números, caracteres
						</label>
					</FormControl>*/}
                    <FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
                        <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-colorPrimary MuiFormLabel-filled MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined css-1jy569b-MuiFormLabel-root-MuiInputLabel-root" >
                            La contraseña nueva debe contener números, caracteres especiales, mayúsculas y minúsculas
                        </label>
                    </FormControl>

                    <FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Contraseña nueva</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Contraseña nueva"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Confirmar contraseña nueva</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPasswordConfirm ? 'text' : 'password'}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPasswordConfirm}
                                        onMouseDown={handleMouseDownPasswordConfirm}
                                        edge="end"
                                    >
                                        {showPasswordConfirm ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Confirmar contraseña nueva"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </FormControl>






                    {
                        !showErrors.state ?
                            <>
                                {showErrors.errors.map((error: any) => {
                                    return <p style={{ color: "red" }}>*{error.message}</p>
                                })}
                            </> :
                            <></>
                    }
                    {
                        loginError === '' ?
                            <></> :
                            <p style={{ color: "red" }}>*{loginError}</p>
                    }
                    <Stack spacing={1} direction="row" justifyContent="center" marginTop={2}>
                        <Button variant="contained" onClick={handleChange} className="app-primary-button" >
                            {loading ? <CircularProgress size={24} color="inherit" /> : "Cambiar"}
                        </Button>
                    </Stack>
                </div>

                <Dialog
                    open={open && showErrors.state}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleCloseModal}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Confirmación de cambio de contraseña"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Se ha cambiado la contraseña con éxito.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Link to={`/`} onClick={handleCloseModal}>
                            <Button>Cerrar</Button>
                        </Link>
                    </DialogActions>

                </Dialog>

            </Box>

        </div>
    );
};